import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);
export default {
	install(Vue) {
    Vue.prototype.judgetPhone = function(){
      var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      if (isAndroid) {
        return true;
        //安卓
      }else{
        return false;
      }
    },
		// IOS交互
		Vue.prototype.setupWebViewJavascriptBridge = function (callback) {
			if (window.WebViewJavascriptBridge) {
				return callback(window.WebViewJavascriptBridge);
			}
			if (window.WVJBCallbacks) {
				return window.WVJBCallbacks.push(callback);
			}
			window.WVJBCallbacks = [callback];
			var WVJBIframe = document.createElement("iframe");
			WVJBIframe.style.display = "none";
			WVJBIframe.src = "https://__bridge_loaded__";
			document.documentElement.appendChild(WVJBIframe);
			setTimeout(function () {
				document.documentElement.removeChild(WVJBIframe);
			}, 0);
		},
		// 另打开一个页面
		Vue.prototype.linkPhone = function (sendData) {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) { //安卓
				window.javaInterface.detailContent(JSON.stringify(sendData));
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("detailContent", sendData, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 跳登入
		Vue.prototype.login = function () {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.toLogin();
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("toLogin", {}, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 首页获取用户信息
		Vue.prototype.getUserMessage = function () {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				const userinfo = window.javaInterface.getUserInfo();
				window.localStorage.userinfo = userinfo;
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("getUserInfo", function (data, responseCallback) {
						// Toast(JSON.stringify(data));
						window.localStorage.userinfo = JSON.stringify(data);
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(data);
					});
					// bridge.callHandler("getUserInfo", {}, function (response) {
					// 	Toast('111');
					// 	Toast(JSON.parse(response));
					// 	// window.localStorage.userinfo = response;
					// });
				});
			}
		},
		// 跳到矩阵页面
		Vue.prototype.focus = function () {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.toFocus();
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("toFocus", {}, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 矩阵关注刷新页面
		Vue.prototype.toReload = function (name) {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.toReload(name);
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("toReload", name, function (response) {
						console.log(response);
					});
				});
			}
		}
		// 跳到分享
		Vue.prototype.shareContent = function (sendData) {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.shareContent(JSON.stringify(sendData));
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("shareContent", sendData, function (response) {
						console.log(response);
					});
				});
			}
		}
		// 抖音播放
		Vue.prototype.vedioContent = function (sendData) {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.vedioContent(JSON.stringify(sendData));
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("vedioContent", sendData, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 发布
		Vue.prototype.releaseContent = function(){
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if(isAndroid){  //安卓
				window.javaInterface.toRelease();
			}else{ //苹果
				this.setupWebViewJavascriptBridge(function(bridge){
					bridge.registerHandler("testJavascriptHandler", function(data,responseCallback){ //注册
						var responseData = {"Javascript Says": "Right back atcha!"};
						responseCallback(responseData);
					});
					bridge.callHandler("toRelease",{},function(response){
						console.log(response);
					});
				});
			}
		},
		// 更换标题
		Vue.prototype.changeTitle = function (sendData) {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.changeTitle(sendData);
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("changeTitle", sendData, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 返回上一级
		Vue.prototype.returnPage = function () {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.goBack();
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("goBack", {}, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 文明实践中心跳转
		Vue.prototype.goCivilization = function () {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.toCivilization();
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("toCivilization", {}, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 跳APP页面
		Vue.prototype.goApp = function (sendData) {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
			if (isAndroid) {  //安卓
				window.javaInterface.toApp(sendData);
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler("toApp", sendData, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 交互统一方法
		// toRefreshPunch  //打卡刷新方法
		Vue.prototype.currency = function (title, sendData) {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
      if (isAndroid) {  //安卓
        if(sendData){
          window.javaInterface[title](sendData);
        }else{
          window.javaInterface[title]();
        }
			} else { //苹果
				this.setupWebViewJavascriptBridge(function (bridge) {
					bridge.registerHandler("testJavascriptHandler", function (data, responseCallback) { //注册
						var responseData = { "Javascript Says": "Right back atcha!" };
						responseCallback(responseData);
					});
					bridge.callHandler(title, sendData, function (response) {
						console.log(response);
					});
				});
			}
		},
		// 返回上一层
		Vue.prototype.goBackPage = function (router) {
			router.back(-1);
		},
		// 判断是否登录
		Vue.prototype.isToken = function () {
			let token = window.localStorage.userinfo?JSON.parse(window.localStorage.userinfo).token:false
			if (token) {
				return true
			} else {
				this.login();
				return false
			}
		},
		//判断什么端打开
		Vue.prototype.os = function () {
			var ua = navigator.userAgent,
				isWindowsPhone = /(?:Windows Phone)/.test(ua),
				isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
				isAndroid = /(?:Android)/.test(ua),
				isFireFox = /(?:Firefox)/.test(ua),
				isChrome = /(?:Chrome|CriOS)/.test(ua),
				isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
				isPhone = /(?:iPhone)/.test(ua) && !isTablet,
				isPc = !isPhone && !isAndroid && !isSymbian;
			return {
				isTablet: isTablet,
				isPhone: isPhone,
				isAndroid: isAndroid,
				isPc: isPc
			}
		},
		Vue.prototype.TolinkUrl = function (url, title) {
			var link = window.location.href.split("#/")[0] + `#/${url}`; //链接
			let isPhone = !this.os().isPc
			if (isPhone) {
				this.linkPhone({ url: link, title: title })
			} else {
				window.location.href = link;
			}
		}
	}
}
